/* Cascada suave en las franjas de envíos, devoluciones y pago - Salas García Ópticos
   Usa la API de animaciones del navegador, así no depende del CSS de cada bloque. */
(function () {
  'use strict';
  if (!('IntersectionObserver' in window)) return;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var EASE = 'cubic-bezier(0.45, 0.05, 0.25, 1)';
  var GROUPS = [
    { box: '.sgo-shipping', items: '.sgo-row' },
    { box: '.sgf-grid', items: '.sgf-item' }
  ];
  var START = 100;
  var STEP = 200;

  function each(list, fn) { Array.prototype.forEach.call(list, fn); }

  function reveal(items) {
    each(items, function (el, i) {
      if (!el.animate) { el.style.opacity = ''; return; }
      var frames = reduce
        ? [{ opacity: 0 }, { opacity: 1 }]
        : [{ opacity: 0, transform: 'translateY(28px)' }, { opacity: 1, transform: 'translateY(0)' }];
      var a = el.animate(frames, {
        duration: reduce ? 300 : 1100,
        delay: reduce ? 0 : START + i * STEP,
        easing: EASE,
        fill: 'both'
      });
      a.onfinish = function () { el.style.opacity = ''; a.cancel(); };
    });
  }

  function setup() {
    GROUPS.forEach(function (g) {
      each(document.querySelectorAll(g.box), function (box) {
        if (box.getAttribute('data-sg-rv')) return;
        var items = box.querySelectorAll(g.items);
        if (!items.length) return;
        box.setAttribute('data-sg-rv', '1');
        each(items, function (el) { el.style.opacity = '0'; });

        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (!e.isIntersecting) return;
            io.unobserve(box);
            reveal(items);
          });
        }, { threshold: 0.2 });
        io.observe(box);
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup);
  else setup();
  document.addEventListener('shopify:section:load', setup);
})();